export default __webpack_public_path__ + "static/media/senti.waterworks.black.04353816.svg";